import { VpButton, VpIcon } from '@vtmn-play/react/headless';
import classNames from 'classnames';
import { useTranslations } from 'next-intl';
import { InteractionDetailSkeleton } from '@/app/[locale]/(entity)/components/interaction/loading/InteractionDetailSkeleton';
import { ErrorInfos } from '@/app/components/Error/ErrorInfos';
import { useApiErrorContext } from '@/app/components/Provider';
import { checkIsAnnouncement } from '~/components/Interaction/utils';
import { TabsFilterValue } from '../types/project/tabs';
import { Announcement } from './announcement/Announcement';
import { InteractionDetail } from './interaction/InteractionDetail';
import { useProjectInteractionsContext } from './provider/ProjectInteractionsProvider';
import { useProjectTabsContext } from './provider/ProjectTabsProvider';

export const CardDetail = () => {
  const t = useTranslations('PROJECT');

  const { interaction, isFetchingItem } = useProjectInteractionsContext();
  const { activeInteraction, activeTabFilter, setTab } = useProjectTabsContext();
  const { error } = useApiErrorContext();

  const isOpened = !!interaction || isFetchingItem || !!error;

  const cssClass = classNames('card-detail', {
    'card-detail--opened': isOpened,
  });

  const isAnnouncement = checkIsAnnouncement(interaction);

  const backLabelKey = activeTabFilter === TabsFilterValue.NEWS
    ? 'NEWS.BACK_LABEL'
    : 'STEPS.BACK_LABEL';

  const displaySkeleton
    = (isFetchingItem
      || (!!activeInteraction && interaction?.id !== activeInteraction))
    && !error;

  return (
    <div className={cssClass} data-testid="card-detail">
      <div className="centered-content">
        {isOpened && (
          <div className="card-detail__close">
            <VpButton
              startSlot={<VpIcon name="chevron-left" />}
              variant="tertiary"
              tabIndex={0}
              onClick={() => setTab(activeTabFilter)}
            >
              {t(backLabelKey)}
            </VpButton>
          </div>
        )}
        {displaySkeleton && (
          <InteractionDetailSkeleton />
        )}
        {error && <ErrorInfos />}
        {!displaySkeleton && !error && (
          isAnnouncement
            ? <Announcement />
            : <InteractionDetail interaction={interaction} />
        )}
      </div>
    </div>
  );
};
